export const IconEnter = ({ size = 21, className }) => {
  return (
    <i
      style={{ width: size, height: size }}
      className={`flex items-center justify-center ${className}`}
    >
      <svg
        width="16"
        height="11"
        viewBox="0 0 16 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.44095 5.64508L2.57941 6.5H3.79314H12.584C12.9597 6.5 13.32 6.35074 13.5857 6.08507C13.8514 5.81939 14.0006 5.45906 14.0006 5.08333V1.41667C14.0006 1.30616 14.0445 1.20018 14.1227 1.12204C14.2008 1.0439 14.3068 1 14.4173 1C14.5278 1 14.6338 1.0439 14.7119 1.12204C14.7901 1.20018 14.834 1.30616 14.834 1.41667V5.08333C14.834 5.68007 14.5969 6.25237 14.175 6.67432C13.753 7.09628 13.1807 7.33333 12.584 7.33333H3.79314H2.57941L3.44095 8.18825L4.63262 9.37075L4.6327 9.37084C4.67176 9.40957 4.70275 9.45565 4.72391 9.50643C4.74506 9.5572 4.75595 9.61166 4.75595 9.66667C4.75595 9.72167 4.74506 9.77613 4.72391 9.82691C4.70275 9.87768 4.67176 9.92376 4.6327 9.9625L4.63269 9.96249L4.6298 9.9654C4.59107 10.0045 4.54498 10.0355 4.49421 10.0566C4.44344 10.0778 4.38898 10.0886 4.33397 10.0886C4.27896 10.0886 4.2245 10.0778 4.17373 10.0566C4.12296 10.0355 4.07687 10.0045 4.03814 9.96539L4.03669 9.96395L1.2913 7.21856C1.25481 7.17962 1.22612 7.13403 1.20682 7.08425L1.20691 7.08421L1.20313 7.075C1.16146 6.97356 1.16146 6.85978 1.20313 6.75833L1.20322 6.75837L1.20682 6.74909C1.22612 6.69931 1.25481 6.65371 1.2913 6.61478L4.03669 3.86939C4.11553 3.79054 4.22247 3.74625 4.33397 3.74625C4.44547 3.74625 4.55241 3.79054 4.63125 3.86939C4.71009 3.94823 4.75439 4.05516 4.75439 4.16667C4.75439 4.2779 4.71031 4.38458 4.63182 4.46337C4.63163 4.46356 4.63144 4.46376 4.63125 4.46395L3.44095 5.64508Z"
          fill="black"
          stroke="currentColor"
        />
      </svg>
    </i>
  );
};
